import { CHARTS_COLORS_TXT } from '../constants'
import { TOngoingContractsResponce } from '../types'
import '../styles.scss'
import { useRef } from 'react'
import { Tooltip } from '../../../components/Tooltip/Tooltip'

export const OngoingContactsChart = ({
  data
}: {
  data: TOngoingContractsResponce
}) => {
  const ref = useRef<HTMLDivElement | null>(null)

  return (
    <div
      className="charts_ongoing-contracts_container half-width"
      data-testid="chartsOngoingContractsContainer"
    >
      <div
        className="charts_title new-design"
        data-testid="chartsOngoingContractsTitle"
      >
        Ongoing contracts
      </div>
      <div
        className="charts_ongoing-contracts_total_container row gap-8"
        data-testid="chartsOngoingContractsTotalContainer"
      >
        <div
          className="charts_ongoing-contracts_total"
          data-testid="chartsOngoingContractsTotal"
        >
          {data?.contract_total_count}
        </div>
        <div
          className="charts_ongoing-contracts_total-title"
          data-testid="chartsOngoingContractsTotalTitle"
        >
          Contracts
        </div>
      </div>
      <div
        className="charts_ongoing-contracts_chart"
        ref={ref}
        data-testid="chartsOngoingContractsChart"
      >
        {data &&
          Object.keys(data).map((key) => {
            if (key !== 'contract_total_count' && +data[key] > 0) {
              return (
                <Tooltip
                  title={`${CHARTS_COLORS_TXT[key]?.name}: ${+data[key]}`}
                >
                  <div
                    className="charts_ongoing-contracts_chart-part"
                    key={key}
                    style={{
                      backgroundColor: CHARTS_COLORS_TXT[key]?.color,
                      width: `${
                        100 * (+data[key] / +data?.contract_total_count)
                      }%`
                    }}
                  />
                </Tooltip>
              )
            }
          })}
        {data && !data.contract_total_count && (
          <div
            className="charts_ongoing-contracts_chart-part"
            style={{
              backgroundColor: CHARTS_COLORS_TXT.empty_state.color,
              width: `100%`
            }}
          />
        )}
      </div>
    </div>
  )
}
